import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BaseForm } from "../../../common/form/base-Form";
import { SoggettoPratica } from "../../../common/models/tipologiche/soggetto-pratica";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-parere',
  templateUrl: './form-parere.component.html',
  styleUrls: ['./form-parere.component.css']
})
export class FormParereComponent extends BaseForm implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  tipiNatura: TipoNatura[] = [];
  soggettiOptions: SoggettoPratica[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;
  checkedTipoRichiedente: string;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService) { super();
  }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      // todo: controllare
      if (this.request.fascicolo.richiedenteEsterno) {
        this.checkedTipoRichiedente = 'esterno';
      }

      if (this.request.fascicolo.richiedenteInterno) {
        this.checkedTipoRichiedente = 'interno';
      }

      if (!this.request.fascicolo.richiedenteInterno && !this.request.fascicolo.richiedenteEsterno) {
        this.checkedTipoRichiedente = 'interno';
      }

      this.request.fascicolo.natura = null;
      this.request.fascicolo.flagFondoRischi = false;
      // fine
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura],
      dataRichiesta: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      dataEmissione: [init ? null : this.request.fascicolo.dataEmissione],
      stato: [init ? null : this.request.fascicolo.stato],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      definito: [init ? null : this.request.fascicolo.definito],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      //dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      flagProcessoTelematico: [init ? null : this.request.fascicolo.flagProcessoTelematico],
      tipoRichiedente: [this.checkedTipoRichiedente, Validators.required],
      richiedenteInterno: [init ? null : this.request.fascicolo.richiedenteInterno],
      richiedenteEsterno: [init ? null : this.request.fascicolo.richiedenteEsterno],
      richiesta: [init ? null : this.request.fascicolo.richiesta],
      sintesiParere: [init ? null : this.request.fascicolo.sintesiParere],
      note: [init ? null : this.request.fascicolo.note],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  tipoRichiedenteChanged() {
    if (this.checkedTipoRichiedente === 'interno') {
      this.request.fascicolo.tipoRichiedente = true;
      this.request.fascicolo.richiedenteEsterno = undefined;
    } else if (this.checkedTipoRichiedente === 'esterno') {
      this.request.fascicolo.tipoRichiedente = false;
      this.request.fascicolo.richiedenteInterno = null;
    }
  }

  populateSelect() {


    if (this.soggettiOptions.length === 0) {
      this.helpers.getSoggetti().subscribe(response => this.soggettiOptions = (<SoggettoPratica[]>response));
    }
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    this.saveForm.emit();
  }
}
